import {memo} from 'react'
import {DatePickerV2, TRowFilter, TextInputV2} from '../../../../../components'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {filterSelector, setFilterLogAuth as setFilter} from '../../../../../redux/slices/filterSlices'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterLogAuth: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilter({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div style={{margin: '2px 0'}}>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Username')}
          value={filter?.username ?? ''}
          onChange={({target}) => handleFilterChange({username: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Agent')}
          value={filter?.agent ?? ''}
          onChange={({target}) => handleFilterChange({agent: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('IP Address')}
          value={filter?.ip_addres ?? ''}
          onChange={({target}) => handleFilterChange({ip_addres: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Path')}
          value={filter?.path ?? ''}
          onChange={({target}) => handleFilterChange({path: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Method')}
          value={filter?.method ?? ''}
          onChange={({target}) => handleFilterChange({method: target.value})}
        />
      </td>

      <td>
        <TextInputV2
          placeholder={t('Request')}
          value={filter?.body ?? ''}
          onChange={({target}) => handleFilterChange({body: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('error code')}
          value={filter?.error_code ?? ''}
          onChange={({target}) => handleFilterChange({error_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Message')}
          value={filter?.message ?? ''}
          onChange={({target}) => handleFilterChange({message: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Response')}
          value={filter?.response ?? ''}
          onChange={({target}) => handleFilterChange({response: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Status')}
          value={filter?.status ?? ''}
          onChange={({target}) => handleFilterChange({status: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Created At')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleFilterChange({created_at: startDate})}
        />
      </td>
    </TRowFilter>
  )
})
